/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_CatalogInputs */

const cs_templates_use_catalog = /** @type {(inputs: Templates_Use_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít`)
};

const en_templates_use_catalog = /** @type {(inputs: Templates_Use_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use`)
};

/**
* | output |
* | --- |
* | "Use" |
*
* @param {Templates_Use_CatalogInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_catalog = /** @type {((inputs?: Templates_Use_CatalogInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_CatalogInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_catalog(inputs)
	return cs_templates_use_catalog(inputs)
});